// icons/landlord.svg
export const LandlordIconV2 = (props) => (
  <svg
    className={props.className}
    width="35"
    height="27"
    viewBox="0 0 35 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.1875 3.1875C12.0625 3.1875 13.5625 4.6875 13.5625 6.5625C13.5625 8.4375 11.875 9.75 10.1875 9.75C8.5 9.75 6.8125 8.25 6.8125 6.5625C6.8125 4.875 8.3125 3.1875 10.1875 3.1875ZM10.1875 0.375C6.8125 0.375 4 3.1875 4 6.5625C4 9.9375 6.8125 12.75 10.1875 12.75C13.5625 12.75 16.375 9.9375 16.375 6.5625C16.375 3.1875 13.5625 0.375 10.1875 0.375Z"
      fill="#231F20"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 18.0938C4.58383 18.0938 3.53125 18.956 3.53125 20.625V24.75H0.71875V20.625C0.71875 17.794 2.66617 15.2812 5.5 15.2812H14.875C17.7088 15.2812 19.6562 17.794 19.6562 20.625V24.75H16.8437V20.625C16.8437 18.956 15.7912 18.0938 14.875 18.0938H5.5Z"
      fill="#231F20"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.5625 16.7812C26.7503 16.7812 25.2812 18.2503 25.2812 20.0625C25.2812 21.8747 26.7503 23.3438 28.5625 23.3438C30.3747 23.3438 31.8438 21.8747 31.8438 20.0625C31.8438 18.2503 30.3747 16.7812 28.5625 16.7812ZM22.4688 20.0625C22.4688 16.697 25.197 13.9688 28.5625 13.9688C31.928 13.9688 34.6562 16.697 34.6562 20.0625C34.6562 23.428 31.928 26.1562 28.5625 26.1562C25.197 26.1562 22.4688 23.428 22.4688 20.0625Z"
      fill="#231F20"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.9688 3.9375V15.375H27.1562V3.9375H29.9688Z"
      fill="#231F20"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.75 7.78125H22.5625V4.96875H28.75V7.78125Z"
      fill="#231F20"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.4375 10.2188H28.5625V13.0312H24.4375V10.2188Z"
      fill="#231F20"
    />
  </svg>
);
